"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResearchType = exports.CampaignStatus = exports.CampaignType = void 0;
var CampaignType;
exports.CampaignType = CampaignType;

(function (CampaignType) {
  CampaignType["Activate"] = "activate";
  CampaignType["One2One"] = "standard";
  CampaignType["One2Many"] = "a4m";
  CampaignType["DigitalGiftRedemption"] = "swag digital";
  CampaignType["PhysicalGiftRedemption"] = "swag physical";
  CampaignType["Prospecting"] = "prospecting";
  CampaignType["Influitive"] = "influitive";
})(CampaignType || (exports.CampaignType = CampaignType = {}));

var CampaignStatus;
exports.CampaignStatus = CampaignStatus;

(function (CampaignStatus) {
  CampaignStatus["Active"] = "active";
  CampaignStatus["Draft"] = "draft";
  CampaignStatus["Archived"] = "archived";
  CampaignStatus["Expired"] = "expired";
})(CampaignStatus || (exports.CampaignStatus = CampaignStatus = {}));

var ResearchType;
exports.ResearchType = ResearchType;

(function (ResearchType) {
  ResearchType["Restricted"] = "restrict_research";
  ResearchType["Required"] = "require_research";
  ResearchType["Optional"] = "optional";
})(ResearchType || (exports.ResearchType = ResearchType = {}));